import React, { Component } from "react";
import Dropzone from "react-dropzone";
import Pica from "pica";
import EXIF from "exif-js";
import { BounceLoader } from "react-spinners";

// assets
import Strings from "../../../assets/strings.json";

class Upload extends Component {
  state = {
    files: this.props.value || [],
    lang: document.body.dataset.lang,
    loading: false,
  };

  fileBase64 = (files) => {
    this.setState({ loading: true });
    const promises = files.map(
      (file) =>
        new Promise((resolve, reject) => {
          const pica = Pica();
          const canvas = document.createElement("canvas");
          this.autoRotate(file).then((img) => {
            if (img.width > 1440 && img.width > img.height) {
              canvas.width = 1440;
              canvas.height = Math.round((1440 * img.height) / img.width);
            } else if (img.height > 1440 && img.height > img.width) {
              canvas.height = 1440;
              canvas.width = Math.round((1440 * img.width) / img.height);
            } else {
              canvas.width = img.width;
              canvas.height = img.height;
            }
            pica
              .resize(img, canvas)
              .then((result) => {
                return pica.toBlob(result, "image/jpeg", 0.8);
              })
              .then((blob) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                  resolve(e.target.result);
                };
                reader.readAsDataURL(blob);
              })
              .catch((err) => reject(err));
          });
        })
    );
    Promise.all(promises)
      .then((files) => {
        this.setState((prevState) => {
          const f = prevState.files.concat(files);
          f.length = f.length > 10 ? 10 : f.length;
          this.props.change(this.props.index, f);
          return { files: f, loading: false };
        });
      })
      .catch((err) => console.log(err));
  };

  autoRotate = (img) => {
    return new Promise(function (resolve, reject) {
      EXIF.getData(img, () => {
        const orientation = img.exifdata.Orientation;
        // case 1: normal
        // case 2: horizontal flip
        // case 3: 180° rotate left
        // case 4: vertical flip
        // case 5: vertical flip + 90 rotate right
        // case 6: 90° rotate right
        // case 7: horizontal flip + 90 rotate right
        // case 8: 90° rotate left
        // iphone photo has 1 3 6 8

        const dataURL = URL.createObjectURL(img);

        const imgObj = document.createElement("img");
        imgObj.src = dataURL;

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        imgObj.onload = () => {
          const result_width = imgObj.width;
          const result_height = imgObj.height;

          if (orientation === 3) {
            canvas.width = result_width;
            canvas.height = result_height;
            ctx.translate(result_width, result_height);
            ctx.rotate(Math.PI);
          } else if (orientation === 6) {
            canvas.width = result_height;
            canvas.height = result_width;
            ctx.translate(result_height, 0);
            ctx.rotate(Math.PI / 2);
          } else if (orientation === 8) {
            canvas.width = result_height;
            canvas.height = result_width;
            ctx.translate(0, result_width);
            ctx.rotate(-Math.PI / 2);
          } else {
            canvas.width = result_width;
            canvas.height = result_height;
          }
          ctx.drawImage(imgObj, 0, 0, result_width, result_height);
          resolve(canvas);
        };

        if (img.complete) {
          img.onload();
        }
      });
    });
  };

  removeImage = (index) => {
    this.setState((prevState) => {
      prevState.files.splice(index, 1);
      this.props.change(this.props.index, prevState.files);
      return {
        files: prevState.files,
      };
    });
  };

  render() {
    let main = (
      <div>
        <p>{Strings[this.state.lang].drag}</p>
        <em>{Strings[this.state.lang].dragLimit}</em>
      </div>
    );

    if (this.state.loading) {
      main = <BounceLoader color="#FF4600" />;
    }

    return (
      <Dropzone onDrop={this.fileBase64} autoFocus>
        {({ getRootProps, getInputProps }) => {
          return (
            <section>
              <div
                {...getRootProps({
                  className:
                    "dropzone p-12 border border-color-grey rounded-lg bg-grey-lightest text-center flex items-center justify-center cursor-pointer relative",
                })}
              >
                <label className="hidden" htmlFor="image-upload" tabIndex={-1}>
                  Upload images
                </label>
                <input
                  {...getInputProps({
                    accept: "image/jpeg, image/png",
                    id: "image-upload",
                  })}
                />
                {main}
              </div>
              {this.state.files ? (
                <div className="dopzone-previews flex flex-wrap my-10">
                  {this.state.files.map((el, i) => {
                    return (
                      <div key={i} className="item-preview mr-6 mb-6">
                        <img
                          className="w-40 h-40 object-cover overflow-hidden rounded-lg"
                          src={el}
                          alt="Preview"
                        />
                        <button
                          type="button"
                          className="text-base block text-red p-3 cursor-pointer hover:underline"
                          onClick={() => this.removeImage(i)}
                        >
                          {Strings[this.state.lang].remove}
                        </button>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </section>
          );
        }}
      </Dropzone>
    );
  }
}

export default Upload;
